import {isDevEnv} from '../env';

const endpoints = window ? window.endpoints : null;
const devConfluenceRoot = 'http://localhost:8080/confluence';

/* eslint-disable max-len */
export const routes = {
    data: isDevEnv ? `${devConfluenceRoot}/johnson/data` : endpoints && endpoints.data,
    eventKbArticleClickedHandler: isDevEnv ? `${devConfluenceRoot}/johnson/analytics/kb/event` : endpoints && endpoints.eventKbClickedAnalytics,
    generalKbArticleClickedHandler: isDevEnv ? `${devConfluenceRoot}/johnson/analytics/kb/general` : endpoints && endpoints.generalKbClickedAnalytics,
    confluenceHome: isDevEnv ? `${devConfluenceRoot}/` : endpoints && endpoints.home,
    dismissEvents: isDevEnv ? `${devConfluenceRoot}/johnson/events/dismiss` : endpoints && endpoints.dismissEvents,
    kbLinkStartStopConfluence: 'https://confluence.atlassian.com/display/CONFKB/Startup+check%3A+Starting+Confluence?utm_source=Install&utm_medium=in-product&utm_campaign=csseng_fy18_q3_server_confluence_errorstate',
    findTheLogs: 'https://confluence.atlassian.com/confkb/startup-check-providing-logs-for-support-936509900.html?utm_source=Install&utm_medium=in-product&utm_campaign=csseng_fy18_q3_server_confluence_errorstate',
    addAndRemoveSystemProps: 'https://confluence.atlassian.com/confkb/startup-check-add-or-remove-confluence-system-properties-938861976.html?utm_source=Install&utm_medium=in-product&utm_campaign=csseng_fy18_q3_server_confluence_errorstate',
};



// WEBPACK FOOTER //
// ./src/constants/routes.js